import PropType from 'prop-types';
import React, { Component } from 'react';

class Boundary extends Component {
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error && error.message ? error.message : 'Unknown rendering error',
      errorStack: error && error.stack ? error.stack : ''
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      errorMessage: '',
      errorStack: ''
    };
  }


  componentDidCatch(error) {
    console.error(error);
  }

  render() {
    const { errorMessage, errorStack, hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className="loader" dir="rtl">
          <h3>تعذر تحميل الصفحة بشكل صحيح.</h3>
          <p className="text-subtle">تفاصيل الخطأ:</p>
          <code className="error-boundary-message">{errorMessage}</code>
          {errorStack ? (
            <details className="error-boundary-details">
              <summary>التفاصيل التقنية</summary>
              <pre>{errorStack}</pre>
            </details>
          ) : null}
          <button
            className="button button-small"
            onClick={() => window.location.reload()}
            type="button"
          >
            تحديث الصفحة
          </button>
        </div>
      );
    }

    return children;
  }
}

Boundary.propTypes = {
  children: PropType.oneOfType([
    PropType.arrayOf(PropType.node),
    PropType.node
  ]).isRequired
};

export default Boundary;
